module.exports = __webpack_public_path__ + "media/images/Content-icon-14fb62099594ccf2939c623589a69e3d.svg";